import { useRef, useState, useEffect } from "react";
import { useIntersection } from "react-use";
import { type ErrorResponse, useMoneyHashQuery } from "./useMoneyHashQuery";

export function useMoneyHashQueryOnView<
  TQueryFnData,
  TData = TQueryFnData,
  TQueryKey extends readonly unknown[] = readonly unknown[],
  TError = ErrorResponse,
>(
  options: Parameters<
    typeof useMoneyHashQuery<TQueryFnData, TData, TQueryKey, TError>
  >[0]
) {
  const ref = useRef<HTMLDivElement>(null);
  const [hasBeenInView, setHasBeenInView] = useState(false);

  const intersection = useIntersection(ref, {
    root: null,
    rootMargin: "0px",
    threshold: 0.2,
  });

  useEffect(() => {
    if (intersection?.isIntersecting && !hasBeenInView) {
      setHasBeenInView(true);
    }
  }, [intersection?.isIntersecting, hasBeenInView]);

  const queryResult = useMoneyHashQuery<TQueryFnData, TData, TQueryKey, TError>(
    {
      ...options,
      enabled: hasBeenInView && (options.enabled ?? true),
    }
  );

  return {
    ...queryResult,
    ref,
  };
}
